// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.material-design-icon[data-v-5244e83e] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-details-toggle[data-v-5244e83e] {
  position: fixed;
  width: 44px;
  height: 44px;
  padding: 14px;
  cursor: pointer;
  opacity: .6;
  transform: rotate(180deg);
  background-color: var(--color-main-background);
  z-index: 2000;
}
.app-details-toggle[data-v-5244e83e]:active,
.app-details-toggle[data-v-5244e83e]:hover,
.app-details-toggle[data-v-5244e83e]:focus {
  opacity: 1;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-27fc3f3a] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-content[data-v-27fc3f3a] {
  position: initial;
  z-index: 1000;
  flex-basis: 100vw;
  height: 100%;
  margin: 0 !important;
  background-color: var(--color-main-background);
  min-width: 0;
}
.app-content[data-v-27fc3f3a]:not(.app-content--has-list) {
  overflow: auto;
}
.app-content-wrapper[data-v-27fc3f3a] {
  position: relative;
  width: 100%;
  height: 100%;
}
.app-content-wrapper--mobile.app-content-wrapper--show-list[data-v-27fc3f3a] .app-content-list {
  display: flex;
}
.app-content-wrapper--mobile.app-content-wrapper--show-list[data-v-27fc3f3a] .app-content-details,
.app-content-wrapper--mobile.app-content-wrapper--show-details[data-v-27fc3f3a] .app-content-list {
  display: none;
}
.app-content-wrapper--mobile.app-content-wrapper--show-details[data-v-27fc3f3a] .app-content-details {
  display: block;
}
[data-v-27fc3f3a] .splitpanes.default-theme .app-content-list {
  max-width: none;
  scrollbar-width: auto;
}
[data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__pane {
  background-color: transparent;
  transition: none;
}
[data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__pane-list {
  min-width: 300px;
  position: -webkit-sticky;
  position: sticky;
  top: var(--header-height);
}
@media only screen and (width < 1024px) {
  [data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__pane-list {
    display: none;
  }
}
[data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__pane-details {
  overflow-y: auto;
}
@media only screen and (width < 1024px) {
  [data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__pane-details {
    min-width: 100%;
  }
}
[data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__splitter {
  width: 9px;
  margin-left: -5px;
  background-color: transparent;
  border-left: none;
}
[data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__splitter:before,
[data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__splitter:after {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-4596132f.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,8CAA8C;EAC9C,aAAa;AACf;AACA;;;EAGE,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,8CAA8C;EAC9C,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;;EAEE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;;EAEE,aAAa;AACf","sourcesContent":["@charset \"UTF-8\";\n.material-design-icon[data-v-5244e83e] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-details-toggle[data-v-5244e83e] {\n  position: fixed;\n  width: 44px;\n  height: 44px;\n  padding: 14px;\n  cursor: pointer;\n  opacity: .6;\n  transform: rotate(180deg);\n  background-color: var(--color-main-background);\n  z-index: 2000;\n}\n.app-details-toggle[data-v-5244e83e]:active,\n.app-details-toggle[data-v-5244e83e]:hover,\n.app-details-toggle[data-v-5244e83e]:focus {\n  opacity: 1;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-27fc3f3a] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-content[data-v-27fc3f3a] {\n  position: initial;\n  z-index: 1000;\n  flex-basis: 100vw;\n  height: 100%;\n  margin: 0 !important;\n  background-color: var(--color-main-background);\n  min-width: 0;\n}\n.app-content[data-v-27fc3f3a]:not(.app-content--has-list) {\n  overflow: auto;\n}\n.app-content-wrapper[data-v-27fc3f3a] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.app-content-wrapper--mobile.app-content-wrapper--show-list[data-v-27fc3f3a] .app-content-list {\n  display: flex;\n}\n.app-content-wrapper--mobile.app-content-wrapper--show-list[data-v-27fc3f3a] .app-content-details,\n.app-content-wrapper--mobile.app-content-wrapper--show-details[data-v-27fc3f3a] .app-content-list {\n  display: none;\n}\n.app-content-wrapper--mobile.app-content-wrapper--show-details[data-v-27fc3f3a] .app-content-details {\n  display: block;\n}\n[data-v-27fc3f3a] .splitpanes.default-theme .app-content-list {\n  max-width: none;\n  scrollbar-width: auto;\n}\n[data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__pane {\n  background-color: transparent;\n  transition: none;\n}\n[data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__pane-list {\n  min-width: 300px;\n  position: -webkit-sticky;\n  position: sticky;\n  top: var(--header-height);\n}\n@media only screen and (width < 1024px) {\n  [data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__pane-list {\n    display: none;\n  }\n}\n[data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__pane-details {\n  overflow-y: auto;\n}\n@media only screen and (width < 1024px) {\n  [data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__pane-details {\n    min-width: 100%;\n  }\n}\n[data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__splitter {\n  width: 9px;\n  margin-left: -5px;\n  background-color: transparent;\n  border-left: none;\n}\n[data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__splitter:before,\n[data-v-27fc3f3a] .splitpanes.default-theme .splitpanes__splitter:after {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
